import { useMutation } from "react-query";
import { uploadZip } from "components/photography/lib/photoData";
import { EDITING_SOURCE_MAP } from "components/photography/lib/helpers";

export const useUploadZip = () => {
    return useMutation(({ photoWipKey, zipFile, imageViewCode, localeCode }) => {
        const formData = new FormData();
        formData.append("file", zipFile);
        formData.append("imageView", imageViewCode);
        formData.append("editingSourceId", EDITING_SOURCE_MAP["skipEditing"].toString());
        formData.append("localeCode", localeCode);

        return uploadZip(photoWipKey, formData);
    });
};
